// extracted by mini-css-extract-plugin
export default {"MainContainer":"MainContainer_MainContainer__ens8F","MainContainerMain":"MainContainer_MainContainerMain__4TFVN","MainContainerFooter":"MainContainer_MainContainerFooter__Atrah"};